import { useState, useEffect, useCallback } from 'react';

export const useKeyPress = ({
  targetKey,
  onPress,
  onRelease,
}: {
  targetKey: string;
  onPress?: (event: KeyboardEvent) => void;
  onRelease?: (event: KeyboardEvent) => void;
}) => {
  const [keyPressed, setKeyPressed] = useState(false);

  const downHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        setKeyPressed(true);

        if (onPress) {
          onPress(event);
        }
      }
    },
    [onPress, targetKey],
  );

  const upHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        setKeyPressed(false);

        if (onRelease) {
          onRelease(event);
        }
      }
    },
    [onRelease, targetKey],
  );

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [downHandler, upHandler]);

  return keyPressed;
};
